import LayoutPadrao from '../layouts/LayoutPadrao.vue'
import enviarWhatsappBoletoView from '@/views/mensagens/enviarWhatsappBoletoView.vue'

// Auth check function
const isAuthenticated = (to, from, next) => {
  const isLoggedIn = localStorage.getItem('user') !== null
  if (isLoggedIn) next()
  else next('/login')
}

export default {
  path: '/',
  component: LayoutPadrao,
  beforeEnter: isAuthenticated,
  children: [
    {
      path: 'boleto-enviar-whatsapp',
      name: 'boleto-enviar-whatsapp',
      component: enviarWhatsappBoletoView,
      meta: { 
        requiresAuth: true, 
        title: 'Enviar Boletos Pós',
        nome_fisico: 'boleto-enviar-whatsapp'
      },
    },
    {
      path: '/boleto-pre-enviar-whatsapp',
      name: 'boleto-pre-enviar-whatsapp',
      component: () => import('../views/mensagens/enviarWhatsappBoletoPreView.vue'),
      meta: { 
        requiresAuth: true,
        title: 'Enviar Boletos Pré',
        nome_fisico: 'enviar-whatsapp-prepago'
      }
    }
  ],
}
